import { Switch, Route, Redirect } from "react-router-dom";
import NotFoundPage from "../pages/NotFoundPage/NotFoundPage";
import { Request } from "../pages/Request/Request";
import { Query } from "../pages/Query/Query";
import { Invoice } from "../pages/Invoice/Invoice";
import { Contact } from "../pages/Contact/Contact";
import { Dashboard } from "../pages/dashboard/Dashboard";
import Cart  from "../pages/Cart/Cart";
import { QueryDetail } from "../pages/QueryDetail/QueryDetail";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import VideoModal from "../components/Video/VideoModal";
import { Info } from "../components/Info/Info";
import { What } from "../components/Info/What";
import { Cost } from "../components/Info/Cost";
import { When } from "../components/Info/When";
import TableHeaderProvider from "../components/ColumnHeader/TableHeaderContext";



const Private = () => {
  return (
    <Switch>
      <Redirect exact from="/" to="/score" />
      <Route exact path="/score" component={Dashboard} />
      <Route exact path="/search" component={Request} />
      <Route path="/request/:requestId" component={QueryDetail} />
      <Route exact path="/bills" render={(params) => 
      <TableHeaderProvider><Invoice {...params} /></TableHeaderProvider>
    } />
      <Route exact path="/request" render={(params) => 
      <TableHeaderProvider><Query {...params} /></TableHeaderProvider>
    }  />
      <Route exact path="/contact" component={Contact} />
      <Route exact path="/cart" component={Cart} />
      <Route exact path="/change-password" component={ChangePassword} />
      <Route exact path="/video" component={VideoModal} />
      <Route exact path="/privacity" component={Info} />
      <Route exact path="/legal" component={Info} />
      <Route exact path="/cookies" component={Info} />
      <Route exact path="/info" component={Info} />
      <Route exact path="/what" component={What} />
      <Route exact path="/cost" component={Cost} />
      <Route exact path="/when" component={When} />
      <Route component={NotFoundPage} />
    </Switch>
  );
};

export default Private;
